import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './shop-story_types.2';

export function getPdpShopStory(variable: types.GetPdpShopStoryVariables, options?: GqlRequestOptions) {
  const query = 'query GetPdpShopStory($shop_id: ID!) { has_story(shop_id: $shop_id) { has_story is_new } }';
  return gql_request<types.GetPdpShopStory, types.GetPdpShopStoryVariables>('GetPdpShopStory', query, variable, { use_consumer: true, ...options });
}

